import { NavLink } from "react-router-dom";

import { PRIMARY_NAV_ITEMS, SUPPORT_NAV_ITEMS } from "../routes";
import { Button } from "../components/Button";
import { cx } from "../lib/cx";

interface TopNavProps {
  onOpenMobileNav: () => void;
}

export function TopNav({ onOpenMobileNav }: TopNavProps) {
  return (
    <header className="top-nav-shell">
      <div className="top-nav">
        <NavLink to="/investment-case" className="brand-lockup" aria-label="400 Norwood investment case">
          <span className="brand-mark" />
          <div>
            <div className="brand-title">400 Norwood</div>
            <div className="brand-subtitle">Investor Site</div>
          </div>
        </NavLink>

        <nav className="desktop-nav" aria-label="Primary">
          {PRIMARY_NAV_ITEMS.map((item) => (
            <NavLink key={item.path} to={item.path} className={({ isActive }) => cx("nav-link", isActive && "is-active")} end>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="top-nav-actions">
          <NavLink to="/memo" className="link-button link-button-primary desktop-only">Read Memo</NavLink>
          <Button variant="ghost" className="mobile-nav-button" onClick={onOpenMobileNav} aria-label="Open navigation">
            Menu
          </Button>
        </div>
      </div>

      <div
        className="desktop-only"
        style={{
          borderTop: "1px solid rgba(255,255,255,0.06)",
          background: "rgba(5, 8, 15, 0.38)"
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "12px",
            width: "min(1200px, calc(100vw - 32px))",
            margin: "0 auto",
            padding: "12px 0 14px"
          }}
        >
          <span
            style={{
              fontSize: "0.72rem",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "rgba(198,211,234,0.62)"
            }}
          >
            Appendix / Diligence
          </span>
          <nav
            aria-label="Support and appendix"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px 14px"
            }}
          >
            {SUPPORT_NAV_ITEMS.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end
                className={({ isActive }) => cx("nav-link", isActive && "is-active")}
                style={{
                  fontSize: "0.92rem",
                  opacity: 0.88
                }}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
}
